/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  PagedAndSyncedResultProductOrderStatusSummary,
  SortDirection,
} from '../models/index';
import {
    PagedAndSyncedResultProductOrderStatusSummaryFromJSON,
    PagedAndSyncedResultProductOrderStatusSummaryToJSON,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/index';

export interface GetProductOrderStatusSummariesOfCurrentRetailerRequest {
    offset?: number;
    limit?: number;
    onlyOpen?: boolean;
    manufacturer?: Array<number>;
    productType?: Array<number>;
    fulltextQuery?: string;
    sortByProductNumber?: SortDirection;
    sortByProductManufacturer?: SortDirection;
    sortByProductType?: SortDirection;
    sortByRequestedQuantity?: SortDirection;
    sortByAcceptedQuantity?: SortDirection;
    sortByLastRequestedAt?: SortDirection;
}

/**
 * 
 */
export class ProductOrderStatusResourceApi extends runtime.BaseAPI {

    /**
     * Creates request options for getProductOrderStatusSummariesOfCurrentRetailer without sending the request
     */
    async getProductOrderStatusSummariesOfCurrentRetailerRequestOpts(requestParameters: GetProductOrderStatusSummariesOfCurrentRetailerRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['onlyOpen'] != null) {
            queryParameters['onlyOpen'] = requestParameters['onlyOpen'];
        }

        if (requestParameters['manufacturer'] != null) {
            queryParameters['manufacturer'] = requestParameters['manufacturer'];
        }

        if (requestParameters['productType'] != null) {
            queryParameters['productType'] = requestParameters['productType'];
        }

        if (requestParameters['fulltextQuery'] != null) {
            queryParameters['fulltextQuery'] = requestParameters['fulltextQuery'];
        }

        if (requestParameters['sortByProductNumber'] != null) {
            queryParameters['sortByProductNumber'] = requestParameters['sortByProductNumber'];
        }

        if (requestParameters['sortByProductManufacturer'] != null) {
            queryParameters['sortByProductManufacturer'] = requestParameters['sortByProductManufacturer'];
        }

        if (requestParameters['sortByProductType'] != null) {
            queryParameters['sortByProductType'] = requestParameters['sortByProductType'];
        }

        if (requestParameters['sortByRequestedQuantity'] != null) {
            queryParameters['sortByRequestedQuantity'] = requestParameters['sortByRequestedQuantity'];
        }

        if (requestParameters['sortByAcceptedQuantity'] != null) {
            queryParameters['sortByAcceptedQuantity'] = requestParameters['sortByAcceptedQuantity'];
        }

        if (requestParameters['sortByLastRequestedAt'] != null) {
            queryParameters['sortByLastRequestedAt'] = requestParameters['sortByLastRequestedAt'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/v1/ui/product-order-status`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async getProductOrderStatusSummariesOfCurrentRetailerRaw(requestParameters: GetProductOrderStatusSummariesOfCurrentRetailerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PagedAndSyncedResultProductOrderStatusSummary>> {
        const requestOptions = await this.getProductOrderStatusSummariesOfCurrentRetailerRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PagedAndSyncedResultProductOrderStatusSummaryFromJSON(jsonValue));
    }

    /**
     */
    async getProductOrderStatusSummariesOfCurrentRetailer(requestParameters: GetProductOrderStatusSummariesOfCurrentRetailerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PagedAndSyncedResultProductOrderStatusSummary> {
        const response = await this.getProductOrderStatusSummariesOfCurrentRetailerRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
